export default __webpack_public_path__ + "static/Important-Notice_EGIB_EN-2915d814a040d630a02cca69209363c1.pdf";